import {gql} from '@apollo/client'

export const CREATE_USER = gql`
  mutation createUserMutation($userData: UserInput!) {
    createUserMutation(userData: $userData) {
      user {
        id
      }
      success
      errors {
        field
        message
      }
    }
  }
`

export const EDIT_USER = gql`
  mutation updateUserMutation($userData: UserInput!, $userId: ID!) {
    updateUserMutation(userData: $userData, userId: $userId) {
      user {
        id
      }
      success
      errors {
        field
        message
      }
    }
  }
`

export const TOGGLE_USER_STATUS = gql`
  mutation activateUserMutation($id: Int!, $isActive: Boolean!) {
    activateUserMutation(id: $id, isActive: $isActive) {
      user {
        id
        isActive
      }
    }
  }
`

// String version para uploads con FormData
export const EDIT_USER_STR = `
  mutation updateUserMutation($userData: UserInput!, $userId: ID!) {
    updateUserMutation(userData: $userData, userId: $userId) {
      user {
        id
      }
      success
      errors {
        field
        message
      }
    }
  }
`

export const UPDATE_PASSWORD_ADMIN = gql`
  mutation changeUserPasswordMutation($nuevaClave: String!, $userId: ID!) {
    changeUserPasswordMutation(nuevaClave: $nuevaClave, userId: $userId) {
      success
      errors {
        field
        message
      }
    }
  }
`

export const CHANGE_OWNER_PASSWORD = gql`
  mutation changeOwnPasswordMutation($claveActual: String!, $nuevaClave: String!) {
    changeOwnPasswordMutation(claveActual: $claveActual, nuevaClave: $nuevaClave) {
      success
      errors {
        field
        message
      }
    }
  }
`

export const SET_FORCE_PASSWORD_CHANGE = gql`
  mutation setForcePasswordChangeMutation($userId: ID!, $enabled: Boolean!) {
    setForcePasswordChangeMutation(userId: $userId, enabled: $enabled) {
      success
      forcePasswordChange
      errors {
        field
        message
      }
    }
  }
`

export const RESET_USER_TWO_FACTOR = gql`
  mutation resetUserTwoFactorMutation($userId: ID!) {
    resetUserTwoFactorMutation(userId: $userId) {
      success
      twoFactorEnabled
      twoFactorEmailFallbackEnabled
      errors {
        field
        message
      }
    }
  }
`

export const SET_USER_TWO_FACTOR_EMAIL_FALLBACK = gql`
  mutation setUserTwoFactorEmailFallbackMutation($userId: ID!, $enabled: Boolean!) {
    setUserTwoFactorEmailFallbackMutation(userId: $userId, enabled: $enabled) {
      success
      twoFactorEmailFallbackEnabled
      errors {
        field
        message
      }
    }
  }
`

export const SET_USER_TWO_FACTOR_REQUIRED = gql`
  mutation setUserTwoFactorRequiredMutation($userId: ID!, $enabled: Boolean!) {
    setUserTwoFactorRequiredMutation(userId: $userId, enabled: $enabled) {
      success
      twoFactorRequired
      errors {
        field
        message
      }
    }
  }
`

export const DELETE_USER_PASSKEY = gql`
  mutation deleteUserPasskeyMutation($userId: ID!, $passkeyId: ID!) {
    deleteUserPasskeyMutation(userId: $userId, passkeyId: $passkeyId) {
      success
      errors {
        field
        message
      }
    }
  }
`

export const ADD_USER_TO_PIPELINE = gql`
  mutation addUserToPipeline($pipelineId: Int!, $userId: Int!) {
    addUserToPipeline(pipelineId: $pipelineId, userId: $userId) {
      success
      errors {
        field
        message
      }
    }
  }
`

export const REMOVE_USER_TO_PIPELINE = gql`
  mutation removeUserFromPipeline($pipelineId: Int!, $userId: Int!) {
    removeUserFromPipeline(pipelineId: $pipelineId, userId: $userId) {
      success
      errors {
        field
        message
      }
    }
  }
`

export const REMOVE_USER_FROM_GROUP_ASSIGNMENT = gql`
  mutation removeUserFromGroupAssignment($userId: ID!, $groupAssignmentId: ID!) {
    removeUserFromGroupAssignmentMutation(userId: $userId, groupAssignmentId: $groupAssignmentId) {
      success
      errors {
        field
        message
      }
    }
  }
`

export const ADD_USER_DEDUCTION = gql`
  mutation CommissionUserDeductionCreate($input: commission_deduction_user_input!) {
    CommissionUserDeductionCreate(input: $input) {
      commissionDeductionUser {
        id
      }
      success
      message
      errors {
        field
        message
      }
    }
  }
`

export const EDIT_USER_DEDUCTION = gql`
  mutation CommissionUserDeductionUpdate($id: ID!, $input: commission_deduction_user_input!) {
    CommissionUserDeductionUpdate(input: $input, id: $id) {
      success
      message
      errors {
        field
        message
      }
    }
  }
`

export const DELETE_USER_DEDUCTION = gql`
  mutation CommissionUserDeductionDelete($id: ID!) {
    CommissionUserDeductionDelete(id: $id) {
      success
      errors {
        field
        message
      }
    }
  }
`

export const UPDATE_USER_PREFERENCES = gql`
  mutation UpdateUserPreferences($preferences: JSONString!) {
    updateUserPreferencesMutation(preferences: $preferences) {
      ok
    }
  }
`

export const SET_CHAT_AI_ACTIVE = gql`
  mutation SetChatAiActive($active: Boolean!) {
    setChatAiActiveMutation(active: $active) {
      ok
      active
      error
    }
  }
`
